import api from "./axios";

const ProjectsService = {
	getAll: async () => {
		try {
			const response = await api.get("/projects");
			return response.data;
		} catch (error) {
			console.error("Error fetching projects:", error);
			throw error;
		}
	},

	getById: async (id) => {
		try {
			const response = await api.get(`/projects/${id}`);
			return response.data;
		} catch (error) {
			console.error(`Error fetching project ${id}:`, error);
			throw error;
		}
	},

	create: async (projectData) => {
		try {
			const response = await api.post("/projects", projectData);
			return response.data;
		} catch (error) {
			console.error("Error creating project:", error);
			throw error;
		}
	},

	update: async (id, projectData) => {
		try {
			const response = await api.patch(`/projects/${id}`, projectData);
			return response.data;
		} catch (error) {
			console.error(`Error updating project ${id}:`, error);
			throw error;
		}
	},

	delete: async (id) => {
		try {
			const response = await api.delete(`/projects/${id}`);
			return response.data;
		} catch (error) {
			console.error(`Error deleting project ${id}:`, error);
			throw error;
		}
	},
};

export default ProjectsService;
